module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av55-1474f5c101da0dd6152eb64eed99cd46.jpg";